export const constants = {
  VERSION: process.env.VUE_APP_VERSION,
  BACKEND_URL: "/app", // change '/admin' in routes.js
  SITE_NAME: process.env.VUE_APP_SITE_NAME,
  API_URL: process.env.VUE_APP_API_URL,
  BTN_SIZE: "small",
  DATETIME_FORMAT_TIME_SIMPLE: "HH:mm:ss",
  DATE_FORMAT: "DD.MM.YYYY",
  TIME_FORMAT: "HH:mm",
  MYSQL_DATE_FORMAT: "YYYY-MM-DD",
  MYSQL_DATETIME_FORMAT: "YYYY-MM-DD HH:mm:ss",
  DEFAULT_CHART_COLOR: "#acacac",
  DATATABLE_ITEM_PER_PAGE_OPTIONS: [10, 15, 20, 50, 100],
  COOKIE_PREFIX: "__kursweblara_",
  BRREG_API_URL: "https://data.brreg.no/enhetsregisteret/api/enheter/",
  API1881_API_KEY: process.env.VUE_APP_API1881_API_KEY,
  API1881_API_URL: "https://services.api1881.no",
  BRING_API_UID: "vitali@avalia.no",
  BRING_API_KEY: "a00247be-edd2-4859-9acb-45486ece8da0",
  BRING_API_URL: "https://api.bring.com/pickuppoint/api/",
  SETTING_DEFAULT_LOCALE: "no",
  SETTING_DEFAULT_ROWS_PER_PAGE: 20,
  SIDEBAR_MOBILEBREAKPOINT_WIDTH: 1920
}
